import React from "react";
import AuthForm from "./components/AuthForm";

function PasswordChange() {
  return <AuthForm isPasswordChange={true} />;
}

export default PasswordChange;
